import { emit } from '../../../core/eventBus'
import EVENTS from '../../../core/events'
import { parseInputQuantity } from '../../../utils/quantity'
import { saveAllArticlesState } from '../../../utils/checkboxStorage'

const eventSelectedProducts = ( event ) => {
  let articlesActiveObj = {}
  $('.cart-group .form-check-input').each((key, item) => {
    const article = $(item).parents('.product-item').data('id')

    if (!articlesActiveObj.hasOwnProperty(article)) {
      articlesActiveObj[ article ] = event.currentTarget.checked;
    }
  })

  // Сохраняем состояние всех чекбоксов в localStorage
  saveAllArticlesState(articlesActiveObj);

  let articlesActiveArr = []
  Object.keys(articlesActiveObj).forEach(article => {
    if (articlesActiveObj[article]) {
      articlesActiveArr.push(article)
    }
  })

  emit(EVENTS.SELECTED_PRODUCTS, {
    articleList: articlesActiveArr,
    checkAll: true,
  })
}

const parseProductQuantity = el => parseInputQuantity( el );

const cartTrackFixedElements = () => {
  const elBody = document.querySelector('body')
  const cartAgreeBox = $('[data-cart-agree]')

  let scrollTop = $(window).scrollTop() + $('.header').height()

  // Кнопка «Просмотр взаиморасчётов» в сайдбаре корзины: показываем нижний отступ, если блок вне видимой области
  if (cartAgreeBox.length > 0) {
    const boxBottom = cartAgreeBox.offset().top + cartAgreeBox.outerHeight()
    let cartAgreeBoxShown = scrollTop < boxBottom && boxBottom <= scrollTop + window.screen.height

    elBody.classList.toggle('sticky-cart-agree', !cartAgreeBoxShown)
  }
}

export {
  eventSelectedProducts,
  parseProductQuantity,
  cartTrackFixedElements
}
